export default "__VITE_ASSET__CWiCdxct__"